// extracted by mini-css-extract-plugin
module.exports = {"modalCloseSection":"ModalCloseButton_modalCloseSection__1P81e","button":"ModalCloseButton_button__246fQ"};